import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_GROUP_EXAM_REGISTRATION_INDIVIDUAL_PAYMENT_LINK_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostIndividualPaymentLinkRequest {
  groupExamRegUuid: string;
  individualExamRegUuid: string;
  callbackVariable: {
    candidateName: string
  }
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: undefined, variables: PostIndividualPaymentLinkRequest) => void;
  onError?: (data: AxiosError<GenericErrorResponse>, variables: PostIndividualPaymentLinkRequest) => void;
  onSettled?: () => void;
}

export const usePostGroupExamRegistrationIndividualPaymentLink = ({
  onSuccess,
  onError,
  onSettled,
}: Input) => {
  const postGroupExamRegistrationIndividualPaymentLink = async (
    payload: PostIndividualPaymentLinkRequest
  ) => {
    const res = await axiosClient.post(
      POST_GROUP_EXAM_REGISTRATION_INDIVIDUAL_PAYMENT_LINK_URL(payload.groupExamRegUuid, payload.individualExamRegUuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(postGroupExamRegistrationIndividualPaymentLink, {
    onSuccess,
    onError,
    onSettled,
  });
};
